import React, { Component,Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./store/configureStore";
import { authRoutes, routes } from "./routes";
import { Layout } from "./common/layout";
import { Login, Register, Reset } from './views/auth';
import { PersistGate } from 'redux-persist/integration/react';
import { IntlProvider } from 'react-intl';
import { Toaster } from 'react-hot-toast';
import * as stact from './common/olxstore/olxstoreActions';
import * as UA from './common/userApp/userAppActions';
import $ from "jquery";
import * as i18act from './common/i18n/I18nActions';
import { getJSON } from './common/utils/functions';     //"../utils/functions";
import { withRouter } from "./custom/withRouter";
import Page404 from "./views/misc/components/Page404";
import { Loading } from "./common/navigation";
import NoService from "./views/noservice/components/NoService";
import ProtectedRoute from "./custom/ProtectedRoute";

const STARTUP_NORMAL = 0;
const STARTUP_REGMODE = 1;
const STARTUP_REGEXPIRED = 2;
const STARTUP_PWRESET = 3


class App extends Component {

    state = {
        loggedIn: false,    // does not actually control login
        siteConfig: false,
        siteAdmin: false,
        nosvcmsg: "Loading...",
        pwResetMode: false,
        site: "",
        storeID: "",
        isCustomer: false
    };


    componentDidUpdate(prevProps) {

        // if (this.props.location.hash !== prevProps.location.hash) {
        //     var url = window.location.origin + this.props.location.search + this.props.location.hash;
        //     var pageName = this.props.location.hash.replace("#", "").replace(/^\/+/, '');
        //     if (pageName === null || pageName === '')
        //     {
        //         pageName = "login";
        //     }
        //     // we need to ignore logging for these pages
        //     if (pageName !== "login" && pageName !== "register" && pageName !== "forgot" && pageName !== "AccountLookup"  ) {
        //         this.logActivity("001", url, pageName);
        //     }

        // }
    }


    logActivity(activityCode, arg1, arg2) {
        var sess = store.getState().userapp;
        var apibase = sess.apiBase;
        var tkn = sess.accessToken;

    // get auth bits here
    var hdrs = { 'Content-Type': 'application/x-www-form-urlencoded' };
    hdrs.Authorization = 'Bearer ' + tkn;

    // Get some information about logged in user.                     
    var authHeaders = {};
    authHeaders.Authorization = 'Bearer ' + tkn;

    var url_string = window.location.href;
    var url = new URL(url_string);
    var storeID = url.searchParams.get("store");
    let _url = apibase + "/api/AddLog";

        // We need to get the store details right quick... otherwise the user wont be able to do much
        // At least for now, this is anonymous. 
        $.ajax({
            url: _url,
            type: "POST",
            context: this,
            headers: authHeaders,
            data: {
                StoreID: storeID,
                ActivityType: activityCode, //Shipment Tracking Link Clicked
                Arg1: arg1,
                Arg2: arg2
            },
            success: function (resp) {
                //console.log(resp);
            },
            error: function (err) {
                console.log("Unable to log activity.");
            }
        });
    }

    /*-----------------------------------------------------------------------
     * componentDidMount
     -----------------------------------------------------------------------*/
    componentDidMount() {

        /* This is our very own bootstrap modal functionality to avoid change at several screens. From now onward we should use Modal React-BootStrap */
        $.fn.modal = function (param) {
            if (param === 'show' || param === undefined) {
                $(this).addClass('show');
            } else {
                $(this).removeClass('show');
            }
        }



        /* There must be at least 2 bits of information in the URL
         * 1- The store ID. Site needs to get its configuration from a store, store name, etc. 
         * 2- Site (stub). Informs customer portal how to reach the API to get all other information it needs. 
         * The rest of the information is related to a customer who has to have some prior association with a store which
         * will be reflected in their user name. 
         * */

    var url_string = window.location.href;
    var url = new URL(url_string);
    var site = url.searchParams.get("site");
    var storeID = url.searchParams.get("store");
    var regkey = url.searchParams.get("invkey"); // registration key. Must match server key to allow registration

    // these two fields are a bit redundant... but the prior is our internal record of the password reset request
    // and the latter is the microsoft identity generated token needed for the actual reset. 
    var resetid = url.searchParams.get("resetid"); // password reset key. Must match server key to allow reset. 

    if (site === null || storeID === null) {
      // we don't have the minimum requirements for this application to contact an API 
      // and initialize. 
      this.setState({
        ...this.state,
        nosvcmsg: "Site not configured. Invalid link.",
        site: "",
        storeID: ""
      });
      return;
    }

    // domain where subdomain sites would be located. Ending must be our domain
    var apibase = "";

    if (process.env.NODE_ENV === "development") {
      // dev mode. 
      const prot = window.location.protocol === "http:" ? "http" : "https";
      apibase = `${prot}://${site}.orderlogix.com/olxcart.webapi`;
    }
    else {
      /* production mode. key indicates production or training. For example "thane" or "thane_train". Truncate the _train" and 
       * adjust the URL accordingly */
      if (site.includes("train")) {
        site = site.replace("train", ""); // remove train hint
        apibase = "https://" + site + ".ordermanagement.com/training/olxcart.webapi";
      }
      else if (site === "test") {
          // local web server
          const prot = window.location.protocol === "http:" ? "http" : "https";
          apibase = `${prot}://${site}.ordermanagement.com/olxcart.webapi`;
      }
      else apibase = "https://" + site + ".ordermanagement.com/production/olxcart.webapi";
    }

    //this.setCookie(UA.SET_API_BASE, apibase);

    // this is the store ID, we have to make a API call to this right away get store details, otherwise
    // we won't know what kind of non-customer specific details to display... store name, images, etc. 


    /* store configureation URL. To save a round trip we also pass the registration key if provided
    * so we can detect if the registration has already been converted into an account. We don't return
    * any information about the account, just an indicator that the registration is consumed so we don't
    * need to go to the registration page. It can also return a response that the registration is expired. 
    */

    let _url = apibase + "/api/account/config/" + storeID;
    if (regkey !== null) _url = apibase + "/api/account/config/" + storeID + "/regkey/" + regkey;
    if (resetid !== null) _url = apibase + "/api/account/config/" + storeID + "/reset/" + resetid;


    // We need to get the store details right quick... otherwise the user wont be able to do much
    // At least for now, this is anonymous. 
    $.ajax({
      url: _url,
      type: "GET",
      context: this,
      success: function (resp) {
        if (resp.length === 0) {

          // clear these because they are used by render
          this.setState({
            nosvcmsg: "Invalid store ID.",
            site: "",
            storeID: ""
          });
          return;
        }


        var langKey = "en";

        var lsPortalLangauge = localStorage.getItem('PortalLangauge')

        if (lsPortalLangauge) {

          if (lsPortalLangauge.toLowerCase() === "en") {
            langKey = "en";
          }

          if (lsPortalLangauge.toLowerCase() === "es") {
            langKey = "es";
          }

        } else {

          var urlLowerCased = new URL(window.location.href.toLowerCase());

          var langUrlParam = urlLowerCased.searchParams.get("lang");

          if (langUrlParam) {

            if (langUrlParam.toLowerCase() === "en" || langUrlParam.toLowerCase() === "english") {
              langKey = "en";
            }

            if (langUrlParam.toLowerCase() === "es" || langUrlParam.toLowerCase() === "spanish") {
              langKey = "es";
            }
          }
        }

        if (langKey.toLowerCase() === "en") {
          this.setLanguage({
            key: "us",
            alt: "United States",
            title: "English (US)"
          });
        }

        if (langKey.toLowerCase() === "es") {
          this.setLanguage({
            key: "es",
            alt: "Spanish",
            title: "Español"
          });
        }

        // normal mode... clear regkey that might be cached memory. 
        if (resp[0].startupMode === STARTUP_NORMAL) {
          this.setCookie(UA.SET_REGKEY, "");
        }


        if (resp[0].startupMode === STARTUP_REGMODE) {
          // server confirmed that registration key is valid. Set to session storage  so that
          // registration page will be displayed. 
          this.setCookie(UA.SET_REGKEY, regkey);
        }

        if (resp[0].startupMode === STARTUP_REGEXPIRED) {
          // Registration key no longer valid... let user try to relocate/refresh invitation`
          this.setCookie(UA.SET_REGKEY, "expired");
        }

        // Save API base and reset token (if applicable)
        this.setCookie(UA.SET_API_BASE, apibase);

        // store config obtained.... goood. This is trigger rerender when we have site details
        this.setState({
          ...this.state,
          siteConfig: true,
          site: site,
            storeID: storeID,
            pwResetMode: (resp[0].startupMode === STARTUP_PWRESET) ? true : false
        });

        // Deserialize some objects that we encoded. 
        resp[0].paymentConfig = JSON.parse(resp[0].paymentConfig);
        if (resp[0].paymentConfig.tokenKey2 === undefined) resp[0].paymentConfig.tokenKey2 = ""; // may not be in config yet... add
        store.dispatch({ type: "SMART_SKIN", payload: { name: resp[0].themeName } });
        resp[0].subscriptionOptions = JSON.parse(resp[0].subOpts)

        // dispatch all settings to store. 
        store.dispatch({ type: stact.STORE_ALL_SET, val: resp[0] });

        // preset email if portal config identified an existing user of invitation 
        if (resp[0].startupMode === STARTUP_NORMAL || resp[0].startupMode === STARTUP_REGMODE || resp[0].startupMode === STARTUP_PWRESET) {
          store.dispatch({
            type: UA.SET_EMAIL,
            val: {
              email: resp[0].inviteEmail,
              forcedPwResetToken: resp[0].forcedPwResetToken
            }
          });
        }

        resp[0].customTranslation = JSON.parse(resp[0].customTranslation);
      },

            error: function (err) {

                // could not obtain store config. Just allow pass-through default site not configured message
                //alert("store config failed. Is store ID correct?");
                console.log("Incorrect store ID provided.");

        // clear these because they are used by render
        this.setState({
          nosvcmsg: "Site configuration error. Please contact administrator",
          site: "",
          storeID: ""
        });
      }
    });

  }


  setLanguage(language) {
    // dispatch english change... after language file is loaded. 
    getJSON("assets/api/langs/" + language.key + ".json").then(data => {
      store.dispatch({
        type: i18act.I18N_SELECT,
        payload: {
          language,
          phrases: data
        }
      });
    });
  }


  setCookie(name, value) {
    // No this isn't actually using cookies because browser too restrictive in incognito mode,
    // and we don't want this data sent back to the server anyway. 
    store.dispatch({ type: name, val: value });

  }

  killCookie(name) {

    if (name === "accessToken") store.dispatch({ type: UA.SET_ACCESS_TOKEN, val: "" });

    // trigger refresh
    this.setState({
      loggedIn: false
    });
  }

  /*-----------------------------------------------------------------------
    * onLoggedIn 
    * This function provides a way for the login screen to signal that
    * login has been successful (so routes to app screens are not intercepted.)
    -----------------------------------------------------------------------*/
  onLoggedIn = (isAdmin, isCustomer, firstName, accessToken) => {


    // store it so the rest of the app can use it. 
    this.setCookie(UA.SET_FIRST_NAME, firstName);
    this.setCookie(UA.SET_ACCESS_TOKEN, accessToken);

    // Now that were logged in, lets get some common information that may be
    // needed by multiple screens... for example Order Data

    // get the order details async
    this.refreshOrders();

    // get the payment details async
    this.refreshPaymethods();

    // get the address details async
    this.refreshAddresses();

      // get subscriptions
    this.refreshSubscriptions();

    // re-render.
    this.setState({
      loggedIn: true,
      siteAdmin: isAdmin,
      isCustomer: isCustomer
    });

    this.applyThemeCustomization();

    this.props.navigate("/welcome");
  }

  applyThemeCustomization() {
    //console.log(store.getState().olxstore.storeOpts.theme);
    const backgroundColor = store.getState().olxstore.storeOpts.theme.backgroundColor;
    const menuColor = store.getState().olxstore.storeOpts.theme.menuColor;
    const menuTextColor = store.getState().olxstore.storeOpts.theme.menuTextColor;// + '!important'; 
    const menuForegroundColor = store.getState().olxstore.storeOpts.theme.menuForegroundColor;

    var r = document.querySelector(':root');
    r.style.setProperty('--theme-primaryhover-color', menuForegroundColor);
    r.style.setProperty('--theme-aside-color', menuColor);
    r.style.setProperty('--theme-menu-color', menuColor);
    r.style.setProperty('--theme-menutext-color', menuTextColor);
    r.style.setProperty('--theme-background-color', backgroundColor);
    r.style.setProperty('--theme-footer-color', store.getState().olxstore.storeOpts.theme.footerColor);
    r.style.setProperty('--theme-footertext-color', store.getState().olxstore.storeOpts.theme.footerTextColor);

    if (store.getState().olxstore.storeOpts.theme.menuColor === store.getState().olxstore.storeOpts.themeDefaults.menuColor) {
      r.style.setProperty('--theme-menu-color', 'none');
    }
  }

  /*-----------------------------------------------------------------------
  * onLoggedOut
  * Clear access token, refresh interface.
  -----------------------------------------------------------------------*/
  onLoggedOut() {
    this.killCookie("accessToken");
  }


  /*-----------------------------------------------------------------------
  * refreshOrders
  * This is located here because it is needed from multiple screens. 
  -----------------------------------------------------------------------*/
  refreshOrders() {


    var sess = store.getState().userapp;
    var apibase = sess.apiBase;
    //console.log("apiBase:" + apibase);
    var tkn = sess.accessToken;

    // get auth bits here
    var hdrs = { 'Content-Type': 'application/x-www-form-urlencoded' };
    hdrs.Authorization = 'Bearer ' + tkn;


    // get order details
    $.ajax({
      url: apibase + "/api/account/orders",
      type: "GET",
      context: this,
      headers: hdrs,
      success: function (resp) {

        //take care of global order manipulations here
        var ts = store.getState();
        var orderPrefixesToStrip = ts.olxstore.storeOpts.orderPrefixesToStrip;

        if (orderPrefixesToStrip !== null) {
          var prefixes = orderPrefixesToStrip.split(",");
          resp.data.forEach((ord) => {
            prefixes.forEach((pfx) => {
              if (ord.value.webOrderNumber.startsWith(pfx)) {
                ord.value.webOrderNumber = ord.value.webOrderNumber.replace(pfx, "");
              }
            });
          });
        }
        //get the shipment details assigned into the items for easier display later
        resp.data.forEach((ord) => {
          ord.value.shipments.forEach((shipment) => {
            shipment.items.forEach((itm) => {
              //get related items and add the details
              let shippedItems = ord.value.items.filter(function (i) {
                return i.id === itm;
              });

              //really only one returned with each iteration
              shippedItems[0].trackingNumber = shipment.trackingNumber;
              shippedItems[0].shipMethod = shipment.shipMethod;
              shippedItems[0].shipmentTransactionID = shipment.id;
            });
          });
        });

        // I assume we have direct access to the store here
        store.dispatch({ type: 'ORDER_SET', val: resp.data });

      },
      error: function (err) {
        //$("#msg").text("Authentication failed");
        alert("Order Data Access failed. Are you logged in?");
      }
    });

  }
  /*-----------------------------------------------------------------------
  * refreshPaymentMethods
  * This is located here because it is needed from multiple screens. 
  -----------------------------------------------------------------------*/
  refreshPaymethods() {

    var sess = store.getState().userapp;
    var apibase = sess.apiBase;
    var tkn = sess.accessToken;

    // get auth bits here
    var hdrs = { 'Content-Type': 'application/x-www-form-urlencoded' };
    hdrs.Authorization = 'Bearer ' + tkn;

    // get the payment details
    $.ajax({
      url: apibase + "/api/account/cards",
      type: "GET",
      context: this,
      headers: hdrs,
      success: function (resp) {
        store.dispatch({ type: 'PAYMENT_SET', val: resp.data });
      },
      error: function (err) {
        //$("#msg").text("Authentication failed");
        alert("Data Access failed. Are you logged in?");
      }
    });
  }

    /*-----------------------------------------------------------------------
    * refreshSubscriptions   
      -----------------------------------------------------------------------*/
    refreshSubscriptions() {
        var sess = store.getState().userapp;
        var apibase = sess.apiBase;
        var tkn = sess.accessToken;

        // get auth bits here
        var hdrs = { 'Content-Type': 'application/x-www-form-urlencoded' };
        hdrs.Authorization = 'Bearer ' + tkn;

        $.ajax({
            url: apibase + "/api/account/autoship",
            type: "GET",
            context: this,
            headers: hdrs,
            success: function (resp) {
                store.dispatch({ type: "SUBS_SET", val: resp });
                console.log("subscription data updated")
            },
            error: function (err) {
                alert("Data Access failed. Are you logged in?");
            }
        });
    }

  /*-----------------------------------------------------------------------
  * refreshAddresses
  * This is located here because it is needed from multiple screens. 
  -----------------------------------------------------------------------*/
  refreshAddresses() {
    // get auth bits here
    var sess = store.getState().userapp;

    var apibase = sess.apiBase;
    var tkn = sess.accessToken;

    var hdrs = { 'Content-Type': 'application/x-www-form-urlencoded' };
    hdrs.Authorization = 'Bearer ' + tkn;

    $.ajax({
      url: apibase + "/api/account/addresses",
      type: "GET",
      context: this,
      headers: hdrs,
      success: function (resp) {
        //console.log("got addresses");
        //this.props.onAddressSet(resp.data);
        store.dispatch({ type: 'ADDRESS_SET', val: resp.data });
      },

      error: function (err) {
        //$("#msg").text("Authentication failed");
        alert("Address Data Access failed. Are you logged in?");
      }
    });
  }



  /*-----------------------------------------------------------------------
  * onRegistered
  * If user successfully registers, we can take them out of registration
  * mode    
  -----------------------------------------------------------------------*/
  onRegistered = () => {
    alert("registration complete");
  }

    /*-----------------------------------------------------------------------
     * onRefreshEntity
     * This function is passed into all the top-level view components. 
     * Provides a way for these components to request a refresh of this data
     * that may be shared by multiple views. 
     -----------------------------------------------------------------------*/
  onRefreshEntity(entname) {
      if (entname === "paymethod" || entname=== "all") this.refreshPaymethods();
      if (entname === "addresses" || entname ==="Subscriptions" || entname ==="all") this.refreshAddresses();
      if (entname === "orders" || entname === "all") this.refreshOrders();
      if (entname === "Subscriptions" || entname === "all") this.refreshSubscriptions(); 

  }

  /*-----------------------------------------------------------------------
   * onPasswordChanged
   * After successful password change, come out of reset mode and let the
   * user login normally. Clear PW change intercept route
   *---------------------------------------------------------------------*/
  onPasswordChanged() {
    this.setState({
      ...this.state,
      pwResetMode: false
    });


  }


  /*-----------------------------------------------------------------------
  login()
  Moved login from Login.js to here because this function needs to be called
  from login & reset pages
   *---------------------------------------------------------------------*/
  login = (email, password,history) => {

    var sess = store.getState().userapp;

    //getSessionData(); 
    var apibase = sess.apiBase;  // this.props.apiBase;
    let _user = email;
    let _password = password;

    let accessToken = "";

    // FIXME... REMOVE THIS!
    if (_user === "" || _user === "tom@nada.net") {
      if (_user === "") _user = "jdaniels@nada.net";  // Non admin. "tom@nada.net" is test Admin 
      if (_password==="") _password = "ad#5%f3sW";   // DEBUG
    }

    // ACTUAL login is {StoreID}_{email}... but user doesn't have to know this. 
    var storeid = this.state.storeID; //  this.props.storeID; // store id is needed to verify invitation and create user. 
    storeid = storeid.replace(/-/g, ''); // store part of user name doesn't include dashes. 
    _user = storeid + "_" + _user;

    $.ajax(
      {
        url: apibase + "/TOKEN",

        type: "POST",
        context: this,
        data: $.param({ grant_type: 'password', username: _user, password: _password }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        success: function (resp) {
          // Login successful... store access token for the rest of the API calls which will require it. 
          accessToken = resp.access_token;

          // Get some information about logged in user.                     
          var authHeaders = {};
          authHeaders.Authorization = 'Bearer ' + resp.access_token;

          $.ajax({
            url: apibase + "/api/Account/UserInfo",
            type: "GET",
            context: this,
            headers: authHeaders,
            success: function (response) {
              // Navigate to home page.
              store.dispatch({
                type: 'USER_CHANGE', val: {

                  firstName: response.firstName,
                  isAdmin: response.isAdmin,
                  isSupport: response.isSupport,
                  isCustomer: response.isCustomer,
                  pwResetToken: response.forcedPwResetToken,
                  forcedPwChange: response.forcedPwResetToken ? true : false,
                  email: response.email
                }
              });

              // signal to top that we are logged in now. 
              this.onLoggedIn(response.isAdmin, response.isCustomer, response.firstName, accessToken);
              
            }
          });
        },

        error: function (err) {

          // display error text below login fields. 
          $("#lblLoginError").html(err.responseJSON.error_description);
        }
      });
  }


  render() {

    var sess = store.getState().userapp;

        // not logged in intercept routes. We'll allow Login/Register/Lock pages only in this state.
        let nologinir = sess.accessToken ? null : <Route path="/" element={<Login login={this.login} onLoggedIn={this.onLoggedIn} />} />;

        // no service intercept route. A site stub and store id are required in order to know which API to connect with. 
        let nosvcir = null;
        if (this.state.site === "" || this.state.storeID === "") {
            nosvcir = <Route path="/" element={<NoService msg={this.state.nosvcmsg} />} />; // no service intercept route. If site details are not provided 
        }
         
        /* user is visiting site with a registration key. This key can be used 
        * to contact the server and get the registration invitation. The user 
        * will have to provide a matching email address to successfully register
        * and the customer ID will be obtained on the back-end (because it is
        * part of the invitation) */
        const regir = sess.regKey ? <Route path="/" element={<Register onLoggedIn={this.onLoggedIn.bind(this)} />} /> : null;

        /* Password Reset link provided. User will be put into this mode after the reset link is validated by the server
          * during initial configuration call. */
        const resetir = this.state.pwResetMode ? <Route path="/" element={<Reset  {...this.props} onPasswordChange={this.onPasswordChanged.bind(this)} login={this.login.bind(this)} />} /> : null;

        var _main = (
            <IntlProvider locale="en">
                <Suspense fallback={<div>{<Loading/>}</div>}>
                    <Routes>
                        {nosvcir}
                        {resetir}

                        {authRoutes.map((route, idx) => {
                            //   console.log(route);
                            return route.component ? (
                                <Route
                                    key={idx}
                                    path={route.path}
                                    exact={route.exact}
                                    name={route.name}
                                    //   component={props => <route.component {...props} onLoggedIn={this.onLoggedIn} />}
                                    element={<route.component {...this.props} login={this.login} onLoggedIn={this.onLoggedIn} onPasswordChange={this.onPasswordChanged.bind(this)} />}
                                />
                            ) : null;
                        })}

                        {regir}
                        {nologinir}

                        <Route path="/" name="Home" element={<Layout onRefreshEntity={this.onRefreshEntity.bind(this)} onLoggedOut={this.onLoggedOut.bind(this)} />} >
                          
                            {routes.map((itm, idx) => {
                                //    {console.log(itm)}
                                return itm.component ? (
                                    <Route
                                        key={idx}
                                        path={itm.path}
                                        exact={itm.exact}
                                        name={itm.name}
                                        element={<ProtectedRoute isLoggedIn={sess.accessToken ? true : false} ><itm.component  {...this.props} onRefreshEntity={this.onRefreshEntity.bind(this)} onLoggedIn={this.onLoggedIn} /></ProtectedRoute>}
                                    />
                                ) : null;
                            })}
                        </Route>

                        <Route path="*" element={<Page404 />} />
                    </Routes>
                </Suspense>
            </IntlProvider>
        );

        _main = <Provider store={store}><PersistGate loading={null} persistor={persistor}>  <Toaster position="top-center" reverseOrder={false} />{_main}</PersistGate></Provider>;
        // the following can maike the Persistance conditional... but it may not be necessary.       
        /*if (process.env.NODE_ENV === "development") {
            _main = <Provider store={store}><PersistGate loading={null} persistor={persistor}>{_main}</PersistGate></Provider>;         
            //_main = <Provider store={store}>{_main}</Provider>;
        }
        else {
            // don't use local storage persistance. 
            _main = <Provider store={store}>{_main}</Provider>;
        }*/

        return _main;
    }

}

export default withRouter(props => <App {...props} />);
